import SuperScriptText from 'components/library/SuperScriptText';
import React from 'react';
import styled from 'styled-components';

// Groups text with its ® so an inline-flex parent doesn't gap them; inherits the
// parent's font and color, which the global span and `a :hover` resets would otherwise override
export const TrademarkText = styled.span`
  && {
    font: inherit;
    color: inherit;
  }

  && sup {
    color: inherit;
  }
`;

// Function to wrap trademark symbols in sup tags
export const formatTrademarks = (
  text: string,
  isPill?: boolean,
  paddingRight?: string,
): React.ReactNode => {
  const parts = text.split(/([™®])/g);
  return parts.map((part, index) => {
    if (part === '™' || part === '®') {
      return isPill ? (
        <SuperScriptText
          key={index}
          text={part}
          fontSize='75%'
          top='-0.25em'
          lineHeight='0'
          verticalAlign='baseline'
          position='relative'
        />
      ) : (
        <SuperScriptText key={index} text={part} paddingRight={paddingRight} />
      );
    }
    return part;
  });
};
